<template>
  <div>
    <footer class="footer">
      <div class="clearfix"></div>
      <div class="icon-row">
        <div class="footer-icon">
          <h5 class="footer-icon-child"></h5>
          <span class="footer-icon-text">品类齐全，轻松购物</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-2"></h5>
          <span class="footer-icon-text">多仓直发，极速配送</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-3"></h5>
          <span class="footer-icon-text">正品行货，精致服务</span>
        </div>
        <div class="footer-icon">
          <h5 class="footer-icon-child footer-icon-child-4"></h5>
          <span class="footer-icon-text">天天低价，畅选无忧</span>
        </div>
      </div>
      <div class="service-intro">
        <div class="servece-type">
          <div
            class="servece-type-info"
            v-for="(guide, index) in guideArr"
            :key="index"
          >
            <ul>
              <li
                v-for="(item, index) in guide"
                :key="index"
                @click="goArticle(item.id)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="friend-link">
          <div class="friend-link-item">
            <ul>
              <li
                v-for="(link, index) in moreLink"
                :key="index"
                @click="goArticle(link.id)"
              >
                <span
                  class="link-item"
                  :class="{ 'link-last-item': index === 4 }"
                  >{{ link.name }}</span
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="clearfix"></div>
        <Row type="flex" justify="center" class="copyright">
          Copyright © {{ year }} - Present 安徽壹能源科技有限公司 版权所有
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >皖ICP备2020014728号-1</a
          >
        </Row>
        <div class="clearfix"></div>
        <div class="license_tit" @click="clickBtn">增值电信业务经营许可证</div>
      </div>
    </footer>
    <!-- 弹窗 -->
    <div class="popup_box" v-if="show">
      <div @click="show = false" class="close">关闭</div>
      <div class="popup_img">
        <img src="https://yny-file.oss-cn-shanghai.aliyuncs.com/b598d98005d140198000f3fe7d733b42.jpg" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { CellGroup } from "view-design";
export default {
  name: "Footer",
  data() {
    return {
      show: false,
      guideArr: [
        // 导航链接
        [
          { name: "购物指南", id: "1520280287305322498" },
          { name: "购物流程", id: "1520280580109684737" },
          { name: "会员介绍", id: "1520281859712143362" },
          { name: "常见问题", id: "1347433752083324928" },
        ],
        [
          { name: "配送方式", id: "1520282355290132482" },
          { name: "上门自提", id: "1520283086726418433" },
          { name: "配送服务查询", id: "1520283472434614273" },
          { name: "收取标准", id: "1520283559277678594" },
        ],
        [
          { name: "支付方式", id: "1520285840052113409" },
          { name: "在线支付", id: "1520285991575539713" },
          { name: "公司转账", id: "1520286072508829697" },
          { name: "余额支付", id: "1520286130612523010" },
        ],
        [
          { name: "售后服务", id: "1520286884807102466" },
          { name: "售后政策", id: "1520286950217273346" },
          { name: "退款说明", id: "1520286991610859521" },
          { name: "返修/退货", id: "1520287030299119617" },
          { name: "取消订单", id: "1520287071449436162" },
        ],
      ],
      moreLink: [
        { name: "关于我们", id: "1371779742369316864" },
        { name: "联系我们", id: "1371779742369316864" },
        { name: "联系客服", id: "1371779742369316864" },
        { name: "商家帮助", id: "1371779742369316864" },
        { name: "隐私政策", id: "1371779742369316864" },
      ], // 更多链接
      year: new Date().getFullYear(), // 当前年份
    };
  },
  methods: {
    goArticle(id) {
      console.log(id);
      // 跳转文章页
      let routeUrl = this.$router.resolve({
        path: "/article?id=" + id,
      });
      window.open(routeUrl.href, "_blank");
    },
    clickBtn() {
      this.show = true;
      console.log(1);
    },
  },
};
</script>

<style scoped lang="scss">
/*****************************底 部 开 始*****************************/
.license_tit {
  text-align: center;
  color: #2d8cf0;
  cursor: pointer;
}
.popup_box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba($color: #000000, $alpha: 0.7);
  z-index: 9999;
  .popup_img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    img {
      height: 80vh;
    }
  }
  .close {
    position: absolute;
    right: 40px;
    top: 40px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
  }
}
.footer {
  width: 100%;
  height: 380px;
  padding-top: 30px;
  @include background_color($light_background_color);
}
.icon-row {
  margin: 15px auto;
  padding-top: 8px;
  width: 1000px;
  height: 64px;
}
.footer-icon {
  margin-left: 17px;
  margin-right: 17px;
  float: left;
}
.footer-icon-child {
  margin-top: 10px;
  overflow: hidden;
  position: absolute;
  width: 36px;
  height: 42px;
  background-image: url("../../assets/images/footer/ico_service.png");
  text-indent: -999px;
}
.footer-icon-child-2 {
  background-position: 0 -43px;
}
.footer-icon-child-3 {
  background-position: 0 -86px;
}
.footer-icon-child-4 {
  background-position: 0 -129px;
}
.footer-icon-text {
  margin-left: 45px;
  font-size: 18px;
  font-weight: bold;
  line-height: 64px;
}
.service-intro {
  width: 100%;
  border-top: 1px solid $border_color;
}
.servece-type {
  margin: 15px auto;
  width: 800px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.servece-type-info ul {
  list-style: none;
}
.servece-type-info li {
  font-size: 14px;
  cursor: pointer;
  line-height: 26px;
}
.servece-type-info li:first-child {
  font-size: 16px;
  line-height: 28px;
  font-weight: bold;
}

.friend-link {
  display: flex;
  align-items: center;
  width: 908px;
  height: 30px;
  margin: 0px auto;
  border-top: 1px solid $border_color;
}
.friend-link-item {
  margin: 0px auto;
}
.friend-link-item ul {
  list-style: none;
}
.friend-link-item li {
  padding: 5px 0px;
  float: left;
}
.link-item {
  padding: 0px 8px;
  cursor: pointer;
  border-right: 1px solid $border_color;
}
.link-last-item {
  border: none;
}
.copyright {
  width: 100%;
  line-height: 30px;
  text-align: center;
}
.copyright a {
  // color: #232323;
  // font-size: 20px;
  margin-left: 5px;
}
.footer-icon-text {
  @include title_color($light_title_color);
}
.copyright,
.friend-link,
.servece-type-info {
  @include sub_color($light_sub_color);
}
/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue